var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating d-flex justify-center"},[_c('star-rating',{attrs:{"increment":0.01,"read-only":"","show-rating":false,"star-size":45,"active-color":"#5A88FF","rounded-corners":"","inline":""},model:{value:(_vm.score),callback:function ($$v) {_vm.score=$$v},expression:"score"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }